import axios from 'axios';

export const getProductListing = async (payload) => {
  let tProduct;
  await axios
    .get('/api/v1/products/product-listing', { params: { payload } })
    .then((res) => {
      tProduct = res.data;
    })
    .catch((error) => {
      tProduct = null;
    });
  return tProduct;
};

export const getAccessoriesListing = async (payload) => {
  let tProduct;
  await axios
    .get('/api/v1/products/accessories-listing', { params: { payload } })
    .then((res) => {
      tProduct = res.data;
    })
    .catch((error) => {
      tProduct = null;
    });
  return tProduct;
};
